{
	"back": "Back to the monitoring of the calls",
	"cause": {
		"dsu_quota.reconciled": "Night check: a change no fact recorded",
		"offer.accepted": "Offer accepted",
		"offers.launched": "Offers started",
		"ranking.calculated": "Ranking calculated again",
		"residence.funded_beds_corrected": "Beds admitted to funding corrected"
	},
	"error": "The DSU quota could not be loaded. Reload the page.",
	"export": "Export the DSU quota report",
	"figures": {
		"below_threshold": "Below threshold",
		"dsu_seats": "Seats at the DSU rate",
		"funded_beds": "Beds admitted to funding",
		"gap": "Difference",
		"gap_missing_one": "{{count}} seat missing",
		"gap_missing_other": "{{count}} seats missing",
		"gap_none": "None, the quota is in line",
		"missing_data_admin": "Missing data: enter the beds admitted to funding in the residence record.",
		"missing_data_manager": "Missing data: ask the general admin to enter the beds admitted to funding.",
		"open": "Open the DSU quota",
		"summary": "DSU quota: {{seats}} of {{threshold}} required",
		"summary_no_threshold": "DSU quota: {{seats}} seats at the DSU rate",
		"threshold": "Required threshold",
		"title": "DSU quota"
	},
	"history": {
		"columns": {
			"cause": "Cause",
			"date": "Date",
			"dsu_seats": "DSU seats",
			"threshold": "Threshold",
			"uncovered": "Uncovered"
		},
		"empty": "No change recorded.",
		"line": "{{seats}} DSU seats, threshold {{threshold}}, {{uncovered}} uncovered",
		"title": "History of the changes"
	},
	"intro": "At least 30% of the beds admitted to funding go to students at the DSU rate. Here are the seats of the 30% quota of the call and every change of the quota.",
	"ministry": {
		"call_open": "The answer is recorded once the call closes.",
		"document": "Open the document",
		"download_failed": "The document did not open. Try again.",
		"none": "No answer recorded. While DSU seats stay uncovered, the offers wait for the answer.",
		"record": {
			"action": "Upload the answer of the Ministry",
			"answer": "What did the Ministry answer?",
			"confirm": "Record the answer",
			"date": "Day of the answer",
			"denied": "No: the seats stay uncovered",
			"description": "With a yes, the DSU seats left uncovered go to the first of the 70% quota list without a DSU seat, at the DSU rate. The answer is recorded once.",
			"document_hint": "The PDF or the email of the answer of the Ministry.",
			"done": "Answer recorded.",
			"future": "The day cannot be in the future.",
			"granted": "Yes: the uncovered DSU seats go to the 70% list",
			"title": "Answer of the Ministry"
		},
		"recorded": "The Ministry answered on {{day}}. Recorded by {{name}} on {{when}}.",
		"someone": "a user",
		"state": {
			"denied": "No",
			"granted": "Yes",
			"none": "No answer",
			"unlocked": "Offers released"
		},
		"title": "Answer of the Ministry",
		"unlock": {
			"action": "Release the offers",
			"confirm": "Release the offers",
			"description": "The offers start without the answer of the Ministry and the uncovered DSU seats stay uncovered. If the answer comes later, the manager records it and it counts.",
			"done": "Offers released.",
			"reason": "Reason",
			"reason_hint": "At least {{min}} characters: it stays in the log.",
			"title": "Release the offers"
		},
		"unlocked": "Offers released by {{name}} on {{when}}: {{reason}}"
	},
	"not_launched": "The DSU quota counts from the start of the offers: the offers of this residence have not started yet.",
	"not_set": "Not set",
	"page_title": "DSU quota",
	"seats": {
		"beyond_one": "{{count}} seat beyond those of the call",
		"beyond_other": "{{count}} seats beyond those of the call",
		"name_missing": "Name not given",
		"number": "Seat {{number}}",
		"protocol": "Protocol {{protocol}}",
		"since": "Since {{date}}",
		"state": {
			"covered": "Covered",
			"in_progress": "Offer in progress",
			"unassigned": "To assign",
			"uncovered": "Uncovered"
		},
		"title": "Seats of the 30% quota",
		"total_one": "{{count}} seat in the call",
		"total_other": "{{count}} seats in the call"
	}
}
